import apiClient from "./apiClient";

export const getPrescriptionsByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/prescriptions/pet/${id}`, { params: { page, limit } })
    .then(res => res);
export const getPrescriptionsByHistorytId = (id, page = 1, limit = 30) => apiClient
    .get(`/prescriptions/history/${id}`, { params: { page, limit } })
    .then(res => res);
export const getPrescriptionsByHistoryEntrytId = (id, page = 1, limit = 30) => apiClient
    .get(`/prescriptions/history-entry/${id}`, { params: { page, limit } })
    .then(res => res);
export const getPrescriptionById = (id) => apiClient.get(`/prescriptions/${id}`);
export const createPrescription = (data) => apiClient.post("/prescriptions", data);
export const sendPrescriptionEmail = (id) => apiClient.post(`/prescriptions/${id}/email`);
export const updatePrescription = (id, data) => apiClient.put(`/prescriptions/${id}`, data);
export const deletePrescription = (id) => apiClient.delete(`/prescriptions/${id}`);
export const getPrescriptionByReferenceCode = (code) => apiClient.get(`/prescriptions/public/${code}`);